import StoreUtil from '@store/StoreUtil';
import { BetSlipPurchaseType } from '@models/shared/betSlip/betSlipEnums';
import ILottoBetSlipDTO from '@core/models/lottoBetSlip/ILottoBetSlipDto';
import LottoBetSlipToTicketMapper from '@core/mappers/tickets/LottoBetSlipToTicketMapper';
import { TicketType } from '@core/models/tickets/enums';
import selectionGetters from './selections';
import systemGetters from './systems';
import summaryGetters from './summary';
import errorsGetters from './errors';
import ILottoBetSlipState from '../types';

const betSlipToTicketMapper = new LottoBetSlipToTicketMapper();

export default {
    ...selectionGetters,
    ...systemGetters,
    ...summaryGetters,
    ...errorsGetters,

    isEmpty(state: ILottoBetSlipState): boolean {
        return state.selections.length === 0;
    },

    purchaseType: StoreUtil.createSimpleGetter('purchaseType'),
    type: StoreUtil.createSimpleGetter('type'),
    /**
    * Difference between stake and raw stake getter is in only one edge case.
    * If stake input field is empty, raw stake getter will return null and stake
    * getter will return 0.
    */
    rawStake: StoreUtil.createSimpleGetter('stake'),
    stake(state: ILottoBetSlipState): number {
        if (!state.stake) {
            return 0;
        }
        return state.stake;
    },
    numbersDrawn: StoreUtil.createSimpleGetter('event.numbersDrawn'),
    totalNumbers: StoreUtil.createSimpleGetter('event.totalNumbers'),
    maxBettableNumber: StoreUtil.createSimpleGetter('event.maxBettableNumber'),
    maxSelections: StoreUtil.createSimpleGetter('maxSelections'),
    maxSystems: StoreUtil.createSimpleGetter('maxSystems'),
    eventName: StoreUtil.createSimpleGetter('event.name', ''),
    code: StoreUtil.createSimpleGetter('event.code', -1),
    eventId: StoreUtil.createSimpleGetter('event.eventId'),
    lottoId: StoreUtil.createSimpleGetter('event.lottoId'),
    odds: StoreUtil.createSimpleGetter('event.odds', []),
    rules: StoreUtil.createSimpleGetter('event.rules', []),
    eventDate: StoreUtil.createSimpleGetter('event.eventDate'),
    endBet: StoreUtil.createSimpleGetter('event.endBet'),
    isLoading: StoreUtil.createSimpleGetter('isLoading'),

    isOffline(state: ILottoBetSlipState): boolean {
        return state.purchaseType === BetSlipPurchaseType.offline;
    },

    isOnline(state: ILottoBetSlipState, getters: any): boolean {
        return !getters.isOffline;
    },

    /**
     * Lotto betSip is simple if total number of selected combinations is equal or smaller than 1.
     */
    isSimple(state: ILottoBetSlipState, getters: any): boolean {
        return getters.selectionsCount <= getters.maxBettableNumber && getters.selectedCombinationsCount <= 1;
    },

    isSystem(state: ILottoBetSlipState, getters: any): boolean {
        return !getters.isSimple;
    },

    hasBonusInfo(state: ILottoBetSlipState, getters: any): boolean {
        return getters.isOffline;
    },

    betSlipDTO: (state: ILottoBetSlipState, getters: any): ILottoBetSlipDTO => ({
        selections: getters.selections,
        candidateSelection: state.candidateSelection,
        stake: getters.stake,
        maxSystems: getters.maxSystems,
        maxSelections: getters.maxSelections,
        purchaseType: getters.purchaseType,
        totalNumbers: getters.totalNumbers,
        numbersDrawn: getters.numbersDrawn,
        name: getters.eventName,
        code: getters.code,
        eventId: getters.eventId,
        lottoId: getters.lottoId,
        endBet: getters.endBet,
        eventDate: getters.eventDate,
        odds: getters.odds,
        systems: getters.selectedSystems,
        rules: getters.rules,
        payout: state.payout,
    }),

    ticket: (state: ILottoBetSlipState, getters: any) => betSlipToTicketMapper.createTargetObject(
        {
            ...getters.betSlipDTO,
            stakeAfterTax: getters.stakeAfterTax,
        },
        {
            type: TicketType.lotto,
        }
    ),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/lotto/betSlip/getters/index.ts